import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  postWorkingDaysFailure,
  postWorkingDaysSuccess,
} from "../slices/features/workingDays";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* postWorkingDaysSaga(action: any) {
  const { payload } = action;
  const { id, data } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.postWorkingDays,
      baseUrl,
      id,
      data
    );

    yield put(postWorkingDaysSuccess({ ...response }));

    payload?.cbSuccess && payload?.cbSuccess(response);
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(postWorkingDaysFailure({ statusCode, statusText }));
  }
}

export function* watchPostWorkingDays() {
  yield takeLatest(RequestTypes.POST_WORKING_DAYS_REQUEST, postWorkingDaysSaga);
}
